import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ProfileEditorComponent } from './components/profile-editor/profile-editor.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { EditProfileDialog } from './components/edit-profile-dialog/edit-profile-dialog.component';
import { SelectCountryModule } from '../shared/select-country/select-country.module';
import { SelectLocationModule } from '../shared/select-location/select-location.module';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        RouterModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatCardModule,
        MatDialogModule,
        SelectCountryModule,
        SelectLocationModule
     ],
    declarations: [
        ProfileEditorComponent,
        EditProfileDialog
    ],
    exports: [
        ProfileEditorComponent,
        EditProfileDialog
    ]
})
export class ProfileEditorModule {
  
  public getProfileEditorComponent() {
    return ProfileEditorComponent;
  }
  
}